import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=ebc71198&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=ebc71198&prod&scoped=true&lang=scss&"
import style1 from "./contact.vue?vue&type=style&index=1&id=ebc71198&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc71198",
  null
  
)

export default component.exports